<!-- Filter Datatables -->
<section id="ngx-datatable-filter">
    <div class="row">
      <div class="col-12"></div>
      <div class="col-12">
        <div class="card">
          <div class="card-content">
            <div class="card-body">
              <!-- ngx-datatable-filter -->
              <fieldset class="form-group" *ngIf="!isInstructor">
                <div class="row align-items-end mt-0 pagination-body">

                  <div  class="col-12 col-sm-12 col-md-3 col-lg-3 mb-2">
                    <div class="btn-group enrollment-list-btn-info" role="group">
                      <button type="button" *ngFor="let status of statusList" class="btn"
                        [ngClass]="{'btn-primary':activeTab==status?.name,'btn-outline-primary':activeTab!=status?.name}"
                        (click)="activeBatchTab(status?.name)">{{status.displayname}}</button>
                    </div>
                  </div>
                  <div class="col-12 col-sm-12 col-md-9 col-lg-9 mt-2 mb-1">
                    <div class="row-flex">
                      <div class="col-flex-2 mb-1 position-relative">
                        <input id="ngx-filter-ref"
                          class="form-control form-control-sm d-inline-block width-300 ml-1 rounded-right shadow searchInput"
                          type="text" placeholder="Search" />
                        <button class="btn search-btn glow position-absolute" >
                          <i class="ft-search text-white cursor-pointer"></i>
                        </button>
                      </div>
                      <div class="col-flex-2 mb-1">
                        <button class="btn btn-primary btn-block users-list-clear glow mb-0" >
                          Reset
                          <i class="ft-filter text-white cursor-pointer"></i>
                        </button>
                      </div>
                      <div class="col-flex-2 mb-1"
                        *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                        <button type="button" class="btn btn-primary btn-block users-list-clear glow mb-0"
                         routerLink="/batches/create-batch" placement="top" ngbTooltip="Add New">
                          +
                        </button>
                      </div>
  
                    </div>
                  </div>
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 pagination-body header-body mb-2">
                    <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="40"
                      [footerHeight]="40" rowHeight="auto" [limit]="limitRef" [rows]="rows" [externalPaging]="true"
                      [count]="page.totalPages" [offset]="page.pageNumber"
                      (page)="pageChangeData($event)"></ngx-datatable>
                  </div>
                  <div class="col-12">
                    <button *ngIf="guideline_data" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Batch Guideline</button>
                    </div>
                </div>
              </fieldset>
              <ngx-datatable *ngIf="rows?.length >0"
                class="bootstrap core-bootstrap"
                [columnMode]="ColumnMode.force"
                [headerHeight]="50"
                [footerHeight]="50"
                rowHeight="auto"
                [limit]="limitRef"
                [rows]="rows"
                [scrollbarH]="true"
                [columns]="columns"
                [externalPaging]="true"
                [count]="page.totalPages"
                [offset]="page.offset"
                (page)="pageChangeData($event)"
              >
                <ngx-datatable-column  [width]="180"
                  name="Batch Name"
                  prop="name"
                >
                  <ng-template
                    let-row="row"
                    let-name="value"
                    ngx-datatable-cell-template
                  >
                    <div class="d-flex align-items-center">
                      <img
                        class="rounded-circle mr-1"
                        *ngIf="row.image"
                        [src]="imageUrl + row.image"
                        height="32"
                        width="32"
                      />
                        <div *ngIf="!row.image" class="avatar mr-1 ml-0 bg-primary">
                          <div class="avatar-content">{{ name | shortName }}</div>
                        </div>  
                    
                      <div class="cell-line-height cursor-pointer" [routerLink]="['/batches/batch-view', row._id]"
                      (click)="editTag(row._id)">
                        <p class="font-medium-1 line-height-1 mb-0">
                          {{ row.name }}
                        </p>
                        <!-- <span class="text-muted font-small-2">
                          Nuclear Power Engineer</span
                        > -->
                      </div>
                    </div>
                  </ng-template>
                </ngx-datatable-column>
                <!-- <ngx-datatable-column [width]="30"
                  name="Start Date"
                  prop="start_date"
                >
                  <ng-template
                    let-row="row"
                    let-name="value"
                    ngx-datatable-cell-template
                  >
                    <div class="cell-line-height">
                      {{ row.start_date}}
                    </div>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [width]="30"
                  name="Start Time"
                  prop="start_time"
                >
                  <ng-template
                    let-row="row"
                    let-name="value"
                    ngx-datatable-cell-template
                  >
                    <div class="cell-line-height">
                      {{ row.start_time}}
                    </div>
                  </ng-template>
                </ngx-datatable-column>
              
                <ngx-datatable-column [width]="20"
                name="end Time"
                prop="end_time"
              >
                <ng-template
                  let-row="row"
                  let-name="value"
                  ngx-datatable-cell-template
                >
                  <div class="cell-line-height">
                    {{ row.end_time}}
                  </div>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column [width]="20"
              name="Days"
              prop="days"
            >
              <ng-template
                let-row="row"
                let-name="value"
                ngx-datatable-cell-template
              >
                <div class="cell-line-height">
                  {{ row.days}}
                </div>
              </ng-template>
            </ngx-datatable-column> -->
            <ngx-datatable-column name="Status" prop="status" [width]="40">
              <ng-template let-row="row" ngx-datatable-cell-template>
                <p  [matMenuTriggerFor]="emp_status">
                  <span *ngIf="row.status.displayname == 'Current'"
                    [ngClass]="{'bg-light-success badge badge-pill':row.status.displayname == 'Current'}">
                    {{row?.status?.displayname}}
                  </span>
                  <span *ngIf="row.status.displayname == 'Archive'"
                    [ngClass]="{'bg-light-danger badge badge-pill':row.status.displayname == 'Archive'}">
                    {{row?.status?.displayname}}
                  </span>
                  <span *ngIf="row.status.displayname == 'OnHold'"
                    [ngClass]="{'bg-light-warning badge badge-pill':row.status.displayname == 'OnHold'}">
                    {{row?.status?.displayname}}
                  </span>
                </p>
                <mat-menu #emp_status="matMenu">

                  <div>
                    <div *ngFor="let status of statusList">
                      <button mat-menu-item *ngIf="status?.name !== row.status.name"
                        (click)="updateBatchStatus(row._id,status._id)">
                        <span>
                          <span [ngClass]="{'bg-light-success badge badge-pill':status.displayname == 'Current'}"
                            placement="top" *ngIf="status.displayname == 'Current'">{{status.displayname}}</span>
                          <span [ngClass]="{'bg-light-danger badge badge-pill':status.displayname == 'Archive'}"
                            placement="top" *ngIf="status.displayname == 'Archive'">{{status.displayname}}</span>
                          <span [ngClass]="{'bg-light-warning badge badge-pill':status.displayname == 'OnHold'}" placement="top"
                            *ngIf="status.displayname == 'OnHold'">{{status.displayname}}</span>
                        </span>
                      </button>
                    </div>
                  </div>
                </mat-menu>
              </ng-template>
            </ngx-datatable-column>
                <ngx-datatable-column name="Actions" [width]="30" *ngIf=" user_role.roles =='admin' || user_role.roles =='extractor'">
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <i
                      class="ft-edit text-primary cursor-pointer mr-2"
                      [routerLink]="['/batches/edit-batch', row._id]"
                      (click)="editTag(row._id)"
                    ></i>
                    <i *ngIf="user_role.roles =='admin'"
                      class="ft-trash-2 cursor-pointer danger"
                      (click)="confirmDelete(row._id)"
                    ></i>
                  </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
              <div *ngIf="rows?.length ==0" class="row bg-primary bg-lighten-4 rounded  mx-1
              text-center p-1 justify-content-center">
                <p class="mt-1">Data not found.</p>
              </div>
              <!-- ngx-datatable-filter -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!--/ Filter Datatables -->
